"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntlProvider = void 0;
var React = require("react");
var react_intl_1 = require("react-intl");
var TranslationsService_1 = require("../../TranslationsService");
var callbacks_1 = require("../../interfaces/callbacks");
var IntlProvider = function (_super) {
  __extends(IntlProvider, _super);
  function IntlProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      intl: TranslationsService_1.defaultTranslationsService.getIntl()
    };
    _this.handleIntlChange = function (intl) {
      _this.setState({
        intl: intl
      });
    };
    return _this;
  }
  IntlProvider.prototype.componentDidMount = function () {
    TranslationsService_1.defaultTranslationsService.on(callbacks_1.EventType.INTL_CHANGE, this.handleIntlChange);
  };
  IntlProvider.prototype.componentWillUnmount = function () {
    TranslationsService_1.defaultTranslationsService.off(callbacks_1.EventType.INTL_CHANGE, this.handleIntlChange);
  };
  IntlProvider.prototype.render = function () {
    var intl = this.state.intl;
    var children = this.props.children;
    return React.createElement(react_intl_1.RawIntlProvider, {
      value: intl.getIntlObject()
    }, children);
  };
  return IntlProvider;
}(React.PureComponent);
exports.IntlProvider = IntlProvider;